import React, { useState } from 'react'
import ReportLayout from '../../layouts/Report'

import useGetSchools from '../../../hooks/schools/useGetSchools'
import useGetActiveUserDemographicsReport from '../../../hooks/analytics/useGetActiveUserDemographicsReport'
import useExportActiveUserDemographicsReport from '../../../hooks/analytics/useExportActiveUserDemographicsReport'

import FilterTable from '../../sub_components/FilterTable'
import BarChart from '../../sub_components/charts/BarChart'
import PieChart from '../../sub_components/charts/PieChart'

import { IColumnProps, IFilterableDataProps } from '../../../interfaces/table'
import { IChartData } from '../../../interfaces/charts'

const UserDemographicsReport = () => {
    const [schoolFilters, setSchoolFilters] = useState<number[]>([]);

    const filterQuery = new URLSearchParams();
    schoolFilters.forEach((id) => filterQuery.append("school_ids", id.toString()));

    const { data: schools } = useGetSchools();

    const { data: activeUserDemographicsReport } = useGetActiveUserDemographicsReport(filterQuery.toString());

    const { mutate: exportCsv } = useExportActiveUserDemographicsReport();

    let filterTableDataColumns__Schools: IColumnProps[] = [
        { name: "ID", identifier: "id" },
        { name: "School Name", identifier: "name" },
    ];

    let filterTableData__Schools: IFilterableDataProps[] = [];

    if (schools) {
        filterTableData__Schools = schools.map((school) => ({
            id: school.id,
            name: school.name,
        }));
    }

    const trimmedChartDataLabels = (data: IChartData[]): IChartData[] => {
        return data.map((item) => item.name.length > 5 ? { ...item, name: item.name.slice(0, 5) + '...' } : item);
    }

    const onExportCsvReport = () => {
        exportCsv({
            payload: {
                filterQuery: filterQuery.toString(),
            }
        });
    }

    return (
        <ReportLayout>
            <div className='immersion_admin__careers_report'>
                <div className='immersion_admin__careers_report__header'>
                    <div className='immersion_admin__careers_report__header__content'>
                        <h2 className='immersion_admin__careers_report__header__content__title'>Active User Demographics Report</h2>
                        <p className='immersion_admin__careers_report__header__content__description'>
                            This slide gives an overview of active user demographics.
                        </p>
                    </div>
                    <div className='immersion_admin__careers_report__header__actions'>
                        <button className='immersion_admin__btn__primary immersion_admin__careers_report__header__actions__button' onClick={onExportCsvReport}>Export CSV</button>
                    </div>
                </div>

                <div className='immersion_admin__careers_report__chart_body'>
                    <div className='immersion_admin__careers_report__chart__row'>
                        <FilterTable
                            columns={filterTableDataColumns__Schools}
                            data={filterTableData__Schools}
                            enableFilters={true}
                            filters={schoolFilters}
                            setFilters={setSchoolFilters}
                        />
                        {activeUserDemographicsReport?.country_of_origin_chart_data.length ? (
                            <PieChart
                                width={300}
                                height={318}
                                data={activeUserDemographicsReport?.country_of_origin_chart_data ?? []}
                                xLabel="Country of Origin"
                                yLabel="No. of Active Users"
                                color="auto"
                            />
                        ) : (
                            <div className='immersion_admin__careers_report__chart__no_data'>
                                No Country of Origin data available
                            </div>
                        )}
                    </div>
                    <div className='immersion_admin__careers_report__chart__row'>
                        {activeUserDemographicsReport?.career_interest_chart_data.length ? (
                            <BarChart
                                width={600}
                                height={318}
                                data={trimmedChartDataLabels(activeUserDemographicsReport?.career_interest_chart_data ?? [])}
                                xLabel="Career Interest"
                                yLabel="No. of Active Users"
                                xInterval={0}
                            />
                        ) : (
                            <div className='immersion_admin__careers_report__chart__no_data'>
                                No Career Interest data available
                            </div>
                        )}
                        {activeUserDemographicsReport?.career_interest_chart_data.length ? (
                            <PieChart
                                width={300}
                                height={318}
                                data={activeUserDemographicsReport?.career_interest_chart_data ?? []}
                                xLabel="Career Interest"
                                yLabel="No. of Active Users"
                                color="auto"
                            />
                        ) : (
                            <div className='immersion_admin__careers_report__chart__no_data'>
                                No Career Interest data available
                            </div>
                        )}

                    </div>
                    <div className='immersion_admin__careers_report__chart__row'>
                        {activeUserDemographicsReport?.current_status_chart_data.length ? (
                            <PieChart
                                width={300}
                                height={318}
                                data={activeUserDemographicsReport?.current_status_chart_data ?? []}
                                xLabel="Current Status"
                                yLabel="No. of Active Users"
                                color="auto"
                            />
                        ) : (
                            <div className='immersion_admin__careers_report__chart__no_data'>
                                No Career Interest data available
                            </div>
                        )}

                        {activeUserDemographicsReport?.current_immigration_status_chart_data.length ? (
                            <PieChart
                                width={300}
                                height={318}
                                data={activeUserDemographicsReport?.current_immigration_status_chart_data ?? []}
                                xLabel="Current Immigration Status"
                                yLabel="No. of Active Users"
                                color="auto"
                            />
                        ) : (
                            <div className='immersion_admin__careers_report__chart__no_data'>
                                No Current Immigration Status data available
                            </div>
                        )}
                    </div>
                    <div className='immersion_admin__careers_report__chart__row immersion_admin__careers_report__chart__row__width_50'>
                        {activeUserDemographicsReport?.campus_chart_data.length ? (
                            <PieChart
                                width={300}
                                height={318}
                                data={activeUserDemographicsReport?.campus_chart_data ?? []}
                                xLabel="Campus"
                                yLabel="No. of Active Users"
                                color="auto"
                            />
                        ) : (
                            <div className='immersion_admin__careers_report__chart__no_data'>
                                No Campus data available
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </ReportLayout>
    )
}


export default UserDemographicsReport;  